import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=7a0e8a0f&scoped=true"
import script from "./footerNav.vue?vue&type=script&lang=js"
export * from "./footerNav.vue?vue&type=script&lang=js"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=7a0e8a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e8a0f",
  null
  
)

export default component.exports